import { createContext } from "react";

import type { Impulse } from "~/tools/impulse";
import { useRequiredContext } from "~/tools/use-required-context";

import type { TimeRange } from "../../../app/state/view/timeline/TimeRange";
import type { DashboardVariable } from "../../../common/dashboard-spec";

import type { DashboardState } from "./_dashboard-state";

export interface DashboardContextValue {
	timeRange: Impulse<TimeRange>;
	variables: Impulse<ReadonlyArray<DashboardVariable>>;
	state: DashboardState;
}

const DashboardContext = createContext<null | DashboardContextValue>(null);

export const DashboardContextProvider = DashboardContext.Provider;

export function useDashboardContext(): DashboardContextValue {
	return useRequiredContext(DashboardContext, {
		providerName: "DashboardProvider",
	});
}
